
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external_quotations",
      function () {
        return require("private-next-pages/external_quotations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/external_quotations"])
      });
    }
  